import React from 'react';
import { reportResults } from '../constants';
import { DataGrid, DataColumn, DateGridCell, StatusGridCell } from '../components';

class PendingSampleGrid extends React.Component {

    resultTypeFilter(data) {
        let results = {};
        results[reportResults.NO_ACTION_REQUIRED] = StatusGridCell.status.POSITIVE;
        results[reportResults.MARGINAL_RESULTS] = StatusGridCell.status.WARNING;
        results[reportResults.ACTION_REQUIRED] = StatusGridCell.status.ERROR;
        results[reportResults.PENDING] = StatusGridCell.status.PENDING;

        return results[data] || results[reportResults.PENDING];
    }

    labelIdFilter(rowData) {
        return rowData.sampleNumber || rowData.labelId;
    }

    render () {
        return (
            <DataGrid {...this.props} className={['component-pending-sample-grid', this.props.className].join(' ')}>
                <DataColumn columnName="labelId" displayName="Label ID" filter={(data, dataRow) => this.labelIdFilter(dataRow)} />
                <DataColumn columnName="customerName" displayName="Customer Name" />
                <DataColumn columnName="serialNumber" displayName="Serial Number" />
                <DataColumn columnName="sampleDate" displayName="Sample Date" cellComponent={DateGridCell} />
                <DataColumn columnName="result" displayName="Status" cellComponent={StatusGridCell} filter={(data) => this.resultTypeFilter(data)} />
            </DataGrid>
        )
    }
}

export default PendingSampleGrid;



// WEBPACK FOOTER //
// ./web-app/components/pending-sample-grid.jsx